"use strict";
/*
// <copyright file="EventHost.ts" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    /** Representation of an event host which exposes an event interface that can be subscribed and un-subscribed to/from */
    // tslint:disable-next-line:class-name
    var eventHost = /** @class */ (function () {
        function eventHost() {
            this._subscribers = [];
            this._idAllocator = 0;
            this.id = $dyn._observableId++;
        }
        /**
         * Subscribes to the event.
         * @param callback A callback that will be made when raise is called.
         * @param subscriber Represents the this pointer for the callback
         * @returns A subscription id that can be used with the unsubscribe method.
         */
        eventHost.prototype.subscribe = function (callback, subscriber) {
            var subscriptionId = this._idAllocator++;
            this._subscribers[subscriptionId] = arguments;
            return subscriptionId;
        };
        /**
         * Un-subscribes to the event.
         * @param subscriptionId The subscription id returned from the call to subscribe.
         */
        eventHost.prototype.unsubscribe = function (subscriptionId) {
            delete this._subscribers[subscriptionId];
        };
        /**
         * Raises the event to all subscribers.
         * @param varArgs A variable list of event arguments to be passed to subscribers.
         * @param forceChange Indicates whether to force raise change even if the new value is equal to the old value.
         */
        eventHost.prototype.raise = function (varArgs, forceChange) {
            var e_1, _a, e_2, _b;
            if (this._subscribers.length === 0) {
                // Do not need to raise changes if there are no subscribers.
                return;
            }
            else if (this._subscribers.length < 10) {
                // For very small subscribers Array.slice is faster than Object.keys.  This can be common for many observables.
                // Take a "snapshot" of subscribers in case they change during the execution.
                var subscribersSnapshot = this._subscribers.slice(0);
                try {
                    for (var subscribersSnapshot_1 = __values(subscribersSnapshot), subscribersSnapshot_1_1 = subscribersSnapshot_1.next(); !subscribersSnapshot_1_1.done; subscribersSnapshot_1_1 = subscribersSnapshot_1.next()) {
                        var subscription = subscribersSnapshot_1_1.value;
                        if (subscription) {
                            var callback = subscription[0];
                            if (callback) {
                                callback.apply(subscription[1], [varArgs, forceChange]);
                            }
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (subscribersSnapshot_1_1 && !subscribersSnapshot_1_1.done && (_a = subscribersSnapshot_1.return)) _a.call(subscribersSnapshot_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            else {
                // Take a "snapshot" of subscribers in case they change during the execution. Using for Object.keys for better sparse array perf
                var subscriberIds = Object.keys(this._subscribers);
                try {
                    for (var subscriberIds_1 = __values(subscriberIds), subscriberIds_1_1 = subscriberIds_1.next(); !subscriberIds_1_1.done; subscriberIds_1_1 = subscriberIds_1.next()) {
                        var subscriberId = subscriberIds_1_1.value;
                        var subscription = this._subscribers[subscriberId];
                        // Assumes that unsubscribed/deleted subscribers after the snapshot was taken do not need to be notified.
                        if (subscription) {
                            var callback = subscription[0];
                            if (callback) {
                                callback.apply(subscription[1], [varArgs, forceChange]);
                            }
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (subscriberIds_1_1 && !subscriberIds_1_1.done && (_b = subscriberIds_1.return)) _b.call(subscriberIds_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        };
        /**
         * Clears all event subscribers.
         */
        eventHost.prototype.clear = function () {
            this._subscribers = [];
        };
        eventHost.prototype.peek = function () {
        };
        return eventHost;
    }());
    $dyn.eventHost = eventHost;
})($dyn || ($dyn = {}));

//# sourceMappingURL=EventHost.js.map
